import React from "react";
import "../styles/TopBar.css";
import { useGame } from "../GameContext";
const buttonIcons = {
  Control: {
    default: "/img/button/control.svg",
    active: "/img/button/control_2.svg",
  },
  Edit: { default: "/img/button/edit.svg", active: "/img/button/edit_2.svg" },
  Debug: {
    default: "/img/button/debug.svg",
    active: "/img/button/debug_2.svg",
  },
  Run: { default: "/img/button/run.svg", active: "/img/button/run_2.svg" },
};

const TopBar: React.FC = () => {
  const {
    gameMode,
    setGameMode,
    message,
    triggerAction,
    setHelpPanelOpen,
    blockTransButton,
    blockNextButton,
  } = useGame();

  const handleModeChange = (newMode: "Control" | "Edit" | "Debug" | "Run") => {
    setGameMode(newMode);
  };

  const handleMessageClick = () => {
    if (message && message.includes("Попробуй ещё раз")) {
      triggerAction("restart");
    }
  };

  const renderMessage = () => {
    if (!message) return null;
    if (message.includes("Попробуй ещё раз")) {
      const parts = message.split("Попробуй ещё раз");
      return (
        <span style={{ whiteSpace: "nowrap" }}>
          {parts[0]}
          <span
            style={{
              textDecoration: "underline",
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            Попробуй ещё раз
          </span>
          {parts[1]}
        </span>
      );
    }
    if (message.includes("Ты переправил всех персонажей! Молодец!")) {
      const parts = message.split("Ты переправил всех персонажей! Молодец!");
      return (
        <span style={{ whiteSpace: "nowrap" }}>
          <span
            style={{
              fontWeight: "bold",
            }}
          >
            Ты переправил всех персонажей! Молодец!
          </span>
          {parts[1]}
        </span>
      );
    }
    return message;
  };

  return (
    <div className="vod-top-bar-button">
      <div className="vod-top-bar">
        <div className="vod-button-setting">
          <img
            className="vod-icon"
            title="Управление"
            alt = "Управление"
            src={
              gameMode === "Control"
                ? buttonIcons.Control.active
                : buttonIcons.Control.default
            }
            onClick={() => handleModeChange("Control")}
          />
          <img
            className="vod-icon"
            alt="Программирование"
            title="Программирование"
            src={
              gameMode === "Edit"
                ? buttonIcons.Edit.active
                : buttonIcons.Edit.default
            }
            onClick={() => handleModeChange("Edit")}
          />
          {gameMode !== "Run" && (
            <img
              className="vod-icon"
              alt="Отладка"
              title="Отладка"
              src={
                gameMode === "Debug"
                  ? buttonIcons.Debug.active
                  : buttonIcons.Debug.default
              }
              onClick={() => handleModeChange("Debug")}
            />
          )}
          {gameMode !== "Debug" && (
            <img
              className="vod-icon"
              alt="Запуск"
              title="Запуск"
              src={
                gameMode === "Run"
                  ? buttonIcons.Run.active
                  : buttonIcons.Run.default
              }
              onClick={() => handleModeChange("Run")}
            />
          )}
        </div>

        <div
          className="vod-message-bar"
          onClick={handleMessageClick}
          style={{
            cursor:
              message && message.includes("Попробуй ещё раз")
                ? "pointer"
                : "default",
            whiteSpace: "nowrap",
          }}
        >
          {renderMessage()}
        </div>
        <img
          className="vod-icon help"
          alt="Помощь"
          src="/img/help.svg"
          title="Помощь"
          onClick={() => setHelpPanelOpen(true)}
        />
      </div>

      {/* Кнопки действий */}
      {gameMode !== "Debug" && gameMode !== "Run" && (
        <div className="vod-auxButtons" id="edit_buttons">
          <div className="vod-transButtons">
            <img
              src="/img/button/AB.svg"
              className={
                "vod-icon-transButtons" + (blockTransButton ? " blocked" : " ")
              }
              alt="AtoB"
              title="Налить из A в B"
              onClick={() => !blockTransButton && triggerAction("AB")}
            />
            <img
              src="/img/button/BA.svg"
              className={
                "vod-icon-transButtons" + (blockTransButton ? " blocked" : " ")
              }
              alt="BtoA"
              title="Налить из B в A"
              onClick={() => !blockTransButton && triggerAction("BA")}
            />
            <img
              src="/img/button/CA.svg"
              className={
                "vod-icon-transButtons" + (blockTransButton ? " blocked" : " ")
              }
              alt="CtoA"
              title="Налить из C в A"
              onClick={() => !blockTransButton && triggerAction("CA")}
            />
            <img
              src="/img/button/AC.svg"
              className={
                "vod-icon-transButtons" + (blockTransButton ? " blocked" : " ")
              }
              alt="AtoC"
              title="Налить из A в C"
              onClick={() => !blockTransButton && triggerAction("AC")}
            />
            <img
              src="/img/button/BC.svg"
              className={
                "vod-icon-transButtons" + (blockTransButton ? " blocked" : " ")
              }
              alt="BtoC"
              title="Налить из B в C"
              onClick={() => !blockTransButton && triggerAction("BC")}
            />
            <img
              src="/img/button/CB.svg"
              className={
                "vod-icon-transButtons" + (blockTransButton ? " blocked" : " ")
              }
              alt="CtoB"
              title="Налить из C в B"
              onClick={() => !blockTransButton && triggerAction("CB")}
            />
          </div>
        </div>
      )}

      {gameMode === "Run" && (
        <div className="carrier-stopButton">
          <img
            src="/img/button/stop.svg"
            className="carrier-icon stop"
            alt="Stop"
            title="Стоп"
            onClick={() => triggerAction("stop")}
          />
        </div>
      )}
      {gameMode === "Debug" && (
        <div className="vod-nextButton">
          <img
            src="/img/button/next.svg"
            className={"vod-icon next " + (blockNextButton ? " blocked" : " ")}
            alt="Next"
            title="Следующая команда"
            onClick={() => !blockNextButton && triggerAction("next")}
          />
        </div>
      )}
    </div>
  );
};

export default TopBar;
